import { fromPairs, matchesProperty } from 'lodash';

import type { CanvasOptionConfiguration } from 'domains/canvases';
import type { OptionGroupAPIData } from 'domains/option_groups';
import type { Dictionary } from 'types/common_types';

// Parses the options in a query param that are optionGroupId and optionId
// joined by an underscore and separated by dashes
export function parseOptionQueryParam(param: string | null) {
  if (!param) return {};

  const pairs = param
    .split('-')
    .map((pair) => pair.split('_'))
    .map(([optionGroupId, optionId]) => [optionGroupId, parseInt(optionId)]);

  return fromPairs(pairs);
}

// Converts an options object {optionGroupId: optionId} to query param format
export function serializeOptionQueryParam(options: Dictionary<string | number>) {
  return Object.entries(options)
    .map((pair) => pair.join('_'))
    .join('-');
}

export function hasAllRequiredOptionGroups(
  selected: CanvasOptionConfiguration,
  optionGroups: OptionGroupAPIData[]
) {
  return optionGroups
    .filter((og) => og.required)
    .every((og) => {
      const optionId = selected[og.id];
      const asNum = typeof optionId === 'string' ? parseInt(optionId) : optionId;
      return optionId && !!og.options.find(matchesProperty('id', asNum));
    });
}
